export const SUBMIT_REGISTRATION_FORM_START = "SUBMIT_REGISTRATION_FORM_START";
export const SUBMIT_REGISTRATION_FORM_SUCCESS =
  "SUBMIT_REGISTRATION_FORM_SUCCESS";
export const SUBMIT_REGISTRATION_FORM_FAILURE =
  "SUBMIT_REGISTRATION_FORM_FAILURE";
